<template>
  <div>
    <b-table striped hover small outlined :items="filtered_resultats" :fields="fields" @row-clicked="openModal"
      sort-by="Clt" responsive>
      <!-- TEMPLATE ROW NATION -->
      <template slot="cell(Nat)" slot-scope="data">
        <img class="flag-nation" :src="'https://sportips.fr/live/img/Flags/' + data.item.nation + '.jpg'" />
      </template>


      <!-- TEMPLATE ROW AVEC COULEURS -->
      <template v-for="(colored_field, index) in colored_fields" :slot="'cell(' + colored_field + ')'" slot-scope="data">
        <span
          :style="{ color: data.item.sexe === 'F' ? '#800080' : data.item.sexe === 'M' ? '#000080' : '#215b0c', fontWeight: 'bold' }">{{
            data.item[colored_field] }} </span>
      </template>

      <!-- TEMPLATE ROW INFOS -->
      <template slot="cell(Plus)" slot-scope="data">
        <b-button size="sm" @click="openModal(data.item, 0)" class="py-0 btn-informations">
          <v-icon name="info" style="font-size: 10px" />
        </b-button>
        <b-button size="sm" class="diploma-dl-btn py-0" @click="downloadDiploma(data.item)" v-if="diplome != 0">
          <img src="https://sportips.fr/plateformeResultats/assets/school.svg" class="diploma-icon"
            style="height: 10px; fill: white" />
        </b-button>
      </template>
      <!-- TEMPLATE ROW TEMPS -->
      <template slot="cell(Temps)" slot-scope="data">
        <span class="temps_tab">{{ data.item.temps_arrondi }}</span>
      </template>
    </b-table>
    <b-modal v-model="show_modal" ref="modal_coureur" size="xl" :title="'Sportips - ' + nom_epreuve" hide-footer>
      <ModalCoureur :coureur="selectedCoureur" :diplome="diplome" :nom_epreuve="nom_epreuve"></ModalCoureur>
    </b-modal>
  </div>
</template>

<script>
import ModalCoureur from "@/component/Epreuve/ModalCoureur";
export default {
  components: { ModalCoureur },


  data() {
    return {
      selectedCoureur: {},
      show_modal: false,
    };
  },
  computed: {
    filtered_resultats() {
      return this.$store.getters['event/listResultatsFiltered'];
    },
    fields() {

      if (this.$route.query && this.$route.query.id == 1447) {
        // remove field with key "Ecart" or "Moy."
        return this.$store.state.event.data.fields.filter((item) => item.key != "Ecart" && item.key != "Moy.");
      }
      return this.$store.state.event.data.fields;
    },
    colored_fields() {
      return this.$store.state.event.data.colored_fields;
    },
    diplome() {
      return this.$store.state.event.data.diplome;
    },
    nom_epreuve() {
      return this.$store.state.event.data.nom_epreuve;
    },
  },
  methods: {
    openModal(data, index) {
      this.selectedCoureur = data;
      this.selectedCoureur.nb_coureur_in_cat = this.getNbCoureurInCat();
      this.selectedCoureur.nb_coureur_in_sexe = this.getNbCoureurInSexe();
      this.show_modal = true;
    },

    getNbCoureurInCat() {
      const results = this.$store.getters['event/listResultatsUnfiltered'];
      var c = results.filter((item) => item.categorie.includes(this.selectedCoureur.categorie) && item.sexe.includes(this.selectedCoureur.sexe));
      return c.length;
    },
    getNbCoureurInSexe() {
      const results = this.$store.getters['event/listResultatsUnfiltered'];
      var c = results.filter((item) => item.sexe.includes(this.selectedCoureur.sexe));
      return c.length;
    },
    downloadDiploma(data) {
      this.selectedCoureur = data;
      this.selectedCoureur.nb_coureur_in_cat = this.getNbCoureurInCat();
      this.selectedCoureur.nb_coureur_in_sexe = this.getNbCoureurInSexe();
      if (this.diplome != 0) {
        let routeData = this.$router.resolve({
          name: "GetDiploma",
          query: {
            e: this.nom_epreuve,
            id: this.selectedCoureur.id,
            nbc: this.selectedCoureur.nb_coureur_in_cat,
            nbs: this.selectedCoureur.nb_coureur_in_sexe,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        let routeData = this.$router.resolve({
          name: "GetGDiploma",
          query: {
            e: this.nom_epreuve,
            id: this.selectedCoureur.id,
            nbc: this.selectedCoureur.nb_coureur_in_cat,
            nbs: this.selectedCoureur.nb_coureur_in_sexe,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.btn-informations svg {
  font-size: 10px;
  height: 10px;
}

.diploma-dl-btn:hover .diploma-icon {
  filter: invert(59%) sepia(62%) saturate(1607%) hue-rotate(1deg) brightness(98%) contrast(96%);
}

.diploma-icon {
  filter: invert(100%) sepia(2%) saturate(7466%) hue-rotate(261deg) brightness(124%) contrast(100%);
}
</style>
